import * as Yup from 'yup';
import { DictionaryRiverBasinCzDistrict } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryRiverBasinCzDistrict>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
